import { Navigate, useLocation } from 'react-router-dom';

const NavigateWithParams = ({ to }: { to: string }) => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search }} replace />;
};

export default NavigateWithParams;
